import store from "../state/store";

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/auth/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.state.currentUser != null) {
          // Redirect to the home page instead
          next({ name: "default" });
          next();
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/auth/register.vue"),
    meta: {
      title: "Inscription",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.state.currentUser != null) {
          // Redirect to the home page instead
          next({ name: "default" });
          next();
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/landing",
    name: "landing",
    component: () => import("../views/landing/index.vue"),
    meta: {
      title: "Amina - Logiciel de gestion commerciale",
      authRequired: false,
    },
  },
  {
    path: "/register/step2/:user",
    name: "register2",
    component: () => import("../views/auth/step2.vue"),
    meta: {
      title: "Inscription",
      authRequired: false,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.state.currentUser != null) {
          // Redirect to the home page instead
          next({ name: "default" });
          next();
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/profile/change-password",
    name: "change-password",
    component: () => import("../views/auth/changePassword.vue"),
    meta: {
      title: "Changer mon mot de passe",
      authRequired: true,
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      title: "Logout", authRequired: false,
      beforeResolve(routeTo, routeFrom, next) {
        localStorage.clear();
        sessionStorage.clear();
        next();
      },
    },
    component: () => import("../views/auth/login")
  },
  {
    path: "/unauthorized",
    name: "Unauthorized",
    meta: {
      title: "Non Autorisé",
      authRequired: false,
    },
    component: () => import("../views/auth/500.vue"),
  },


  {
    path: "/",
    name: "default",
    meta: {
      title: "Dashboard",
      authRequired: true,
      key: 'dashboard'
    },
    component: () => import("../views/dashboard/index.vue"),
  },
  {
    path: "/commandes",
    name: "commandes",
    meta: {
      title: "Commandes",
      authRequired: true,
      key: 'orders'
    },
    children:[
      {
        path: "clients",
        name: "commandeClients",
        meta: {
          title: "Commande Client",
          authRequired: true,
          key: 'customer-orders'
        },
        children: [
          {
            path: "",
            name: "listeCommandes",
            meta: {
              title: "Commande Client",
              authRequired: true,
              key: 'customer-orders-list'
            },
            component: () => import("../views/commandes/clients/index.vue"),
          },
          {
            path: "create",
            name: "createCommandes",
            meta: {
              title: "Commandes",
              authRequired: true,
              key: 'customer-orders-create'
            },
            component: () => import("../views/commandes/clients/create.vue"),
          },
          {
            path: ":id/bon-commandes",
            name: "venteBonCommandes",
            meta: {
              title: "Commandes",
              authRequired: true,
              key: 'customer-orders-print'

            },
            component: () => import("../views/commandes/clients/bonCommande.vue"),
          },
          {
            path: ":id/edit",
            name: "commandeEdit",
            meta: {
              title: "Commandes",
              authRequired: true,
              key: 'customer-orders-edit'

            },
            component: () => import("../views/commandes/clients/edit.vue"),
          },
        ]
      },
      {
        path: "fournisseurs",
        name: "commandeFournisseurs",
        meta: {
          title: "Commande Fournisseur",
          authRequired: true,
          key: 'purchase-orders'
        },
        children: [
          {
            path: "",
            name: "listCommandeFournisseurs",
            meta: {
              title: "Commande Fournisseur",
              authRequired: true,
              key: 'purchase-orders-list'
            },
            component: () => import("../views/commandes/fournisseurs/index.vue"),
          },
          {
            path: "create",
            name: "createCommandeFournisseurs",
            meta: {
              title: "Commande Fournisseur",
              authRequired: true,
              key: 'purchase-orders-create'
            },
            component: () => import("../views/commandes/fournisseurs/create.vue"),
          },
          {
            path: ":id/edit",
            name: "commandeFournisseurEdit",
            meta: {
              title: "Commande Fournisseur",
              authRequired: true,
              key: 'commande-edit'

            },
            component: () => import("../views/commandes/fournisseurs/edit.vue"),
          },
          {
            path: ":id/invoice",
            name: "commandeAchatInvoice",
            meta: {
              title: "Commandes",
              authRequired: true,
              key: 'sales-invoice-print'

            },
            component: () => import("../views/commandes/fournisseurs/bonCommande.vue"),
          },

        ]
      },
    ]
  },
  {
    path: "/factures",
    name: "factures",
    meta: {
      title: "Factures",
      authRequired: true,
      key: 'invoices'
    },
    children:[
      {
        path: "ventes",
        name: "factureVentes",
        meta: {
          title: "Facture de vente",
          authRequired: true,
          key: 'sales-invoices'
        },
        children: [
          {
            path: "",
            name: "listeFactures",
            meta: {
              title: "Facture de vente",
              authRequired: true,
              key: 'sales-invoice-list'
            },
            component: () => import("../views/factures/clients/index.vue"),
          },
          {
            path: ":id/invoice",
            name: "factureVenteInvoice",
            meta: {
              title: "Commandes",
              authRequired: true,
              key: 'sales-invoice-print'

            },
            component: () => import("../views/factures/clients/invoice.vue"),
          },
          {
            path: ":id/bon-stats",
            name: "factureInvoice",
            meta: {
              title: "Commandes",
              authRequired: true,
              key: 'sales-invoice-bonLivraison-list'

            },
            component: () => import("../views/factures/clients/bon-stats.vue"),
          },
          {
            path: ":id/bon-livraisons",
            name: "factureVenteBonLivraisons",
            meta: {
              title: "Bon de livraison",
              authRequired: true,
              key: 'sales-invoice-bonLivraison'

            },
            children:[
              {
                path: "",
                name: "factureBonLivraisonListe",
                meta: {
                  title: "Bon de livraison",
                  authRequired: true,
                  key: 'sales-invoice-bonLivraison-list'

                },
                component: () => import("../views/factures/clients/bon_livraisons/index.vue"),
              },
              {
                path: "create",
                name: "factureBonLivraisonCreate",
                meta: {
                  title: "Bon de livraison",
                  authRequired: true,
                  key: 'sales-invoice-bonLivraison-create'

                },
                component: () => import("../views/factures/clients/bon_livraisons/create.vue"),
              },
              {
                path: ":bon/print",
                name: "factureBonLivraisonPrint",
                meta: {
                  title: "Bon de livraison",
                  authRequired: true,
                  key: 'sales-invoice-bonLivraison-list'

                },
                component: () => import("../views/factures/clients/bon_livraisons/print.vue"),
              },
            ],
          },
          {
            path: ":id/paiements",
            name: "facturePaiement",
            meta: {
              title: "Facture de vente",
              authRequired: true,
              key: 'sales-invoice-paiement'

            },
            children:[
              {
                path: "",
                name: "factureVenteListePaiements",
                meta: {
                  title: "Facture de vente",
                  authRequired: true,
                  key: 'sales-invoice-paiement-list'

                },
                component: () => import("../views/factures/clients/paiements/index.vue"),
              },
              {
                path: "create",
                name: "factureVentePaiementCreate",
                meta: {
                  title: "Facture de vente",
                  authRequired: true,
                  key: 'sales-invoice-paiement-create'

                },
                component: () => import("../views/factures/clients/paiements/create.vue"),
              },
              {
                path: ":paiement/receipt",
                name: "factureVentePaiementReceipt",
                meta: {
                  title: "Facture de vente",
                  authRequired: true,
                  key: 'sales-invoice-paiement-receipt'

                },
                component: () => import("../views/factures/clients/paiements/receipt.vue"),
              },
            ],
          },
          {
            path: ":id/retours",
            name: "factureRetours",
            meta: {
              title: "Retour de marchandise",
              authRequired: true,
              key: 'facturePaiement'

            },
            children:[
              {
                path: "",
                name: "factureListeRetours",
                meta: {
                  title: "Retour de marchandise",
                  authRequired: true,
                  key: 'sales-invoice-retour-list'

                },
                component: () => import("../views/factures/clients/retours/index.vue"),
              },
              {
                path: "create",
                name: "factureRetourCreate",
                meta: {
                  title: "Retour de marchandise",
                  authRequired: true,
                  key: 'sales-invoice-retour-create'

                },
                component: () => import("../views/factures/clients/retours/create.vue"),
              },
              {
                path: ":paiement/receipt",
                name: "facturePaiementReceipt",
                meta: {
                  title: "Facture de vente",
                  authRequired: true,
                  key: 'vente-bon-livraison-print'

                },
                component: () => import("../views/factures/clients/paiements/receipt.vue"),
              },
            ],
          },
        ]
      },
      {
        path: "achats",
        name: "factureAchats",
        meta: {
          title: "Facture d'achat",
          authRequired: true,
          key: 'invoice-purchases'
        },
        children: [
          {
            path: "",
            name: "listeFactureAchat",
            meta: {
              title: "Facture d'achat",
              authRequired: true,
              key: 'invoice-purchase-list'
            },
            component: () => import("../views/factures/fournisseurs/index.vue"),
          },
          {
            path: ":id/bon-receptions",
            name: "factureAchatBonReception",
            meta: {
              title: "Facture d'achat",
              authRequired: true,
              key: 'invoice-purchase-bon-reception'
            },
            children:[
              {
                path: "",
                name: "factureAchatBonReceptionListe",
                meta: {
                  title: "Facture d'achat",
                  authRequired: true,
                  key: 'invoice-purchase-bon-reception-list'
                },
                component: () => import("../views/factures/fournisseurs/bon_receptions/index.vue"),
              },
              {
                path: "create",
                name: "factureAchatBonReceptionCreate",
                meta: {
                  title: "Facture d'achat",
                  authRequired: true,
                  key: 'invoice-purchase-bon-reception-create'
                },
                component: () => import("../views/factures/fournisseurs/bon_receptions/create.vue"),
              },
              {
                path: ":bon/print",
                name: "factureAchatBonReceptionPrint",
                meta: {
                  title: "Bon de reception",
                  authRequired: true,
                  key: 'invoice-purchase-bon-reception-print'
                },
                component: () => import("../views/factures/fournisseurs/bon_receptions/print.vue"),
              },
            ]
          },
          {
            path: ":id/paiements",
            name: "factureAchatPaiement",
            meta: {
              title: "Facture d'achat",
              authRequired: true,
              key: 'invoice-purchase-paiement'

            },
            children:[
              {
                path: "",
                name: "factureAchatListePaiements",
                meta: {
                  title: "Facture d'achat",
                  authRequired: true,
                  key: 'invoice-purchase-paiement-list'

                },
                component: () => import("../views/factures/fournisseurs/paiements/index.vue"),
              },
              {
                path: "create",
                name: "facturePaiementCreate",
                meta: {
                  title: "Facture de vente",
                  authRequired: true,
                  key: 'invoice-purchase-paiement-create'

                },
                component: () => import("../views/factures/fournisseurs/paiements/create.vue"),
              },
              {
                path: ":paiement/receipt",
                name: "facturePaiementReceipt",
                meta: {
                  title: "Facture de vente",
                  authRequired: true,
                  key: 'invoice-purchase-paiement-receipt'

                },
                component: () => import("../views/factures/clients/paiements/receipt.vue"),
              },

            ],
          },
          {
            path: ":id/invoice",
            name: "factureAchatInvoice",
            meta: {
              title: "Commandes",
              authRequired: true,
              key: 'sales-invoice-print'

            },
            component: () => import("../views/commandes/fournisseurs/bonCommande.vue"),
          },


        ]
      },
    ]
  },

  {
    path: "/rapport-stocks/:id/details",
    name: "rappotStockDetails",
    meta: {
      title: "Rapport de stock",
      authRequired: true,
      key: "rapport-stocks"

    },
    component: () => import("../views/reports/rapport_stock_details.vue"),
  },
  {
    path: "/remboursements",
    name: "remboursements",
    meta: {
      title: "Remboursements",
      authRequired: true,
      key: "remboursements"

    },
    children:[
      {
        path: "",
        name: "listeRemboursements",
        meta: {
          title: "Remboursements",
          authRequired: true,
          key: "remboursement-list"

        },
        component: () => import("../views/remboursements/index.vue"),
      },
      {
        path: ":id/pay",
        name: "payRemboursements",
        meta: {
          title: "Remboursements",
          authRequired: true,
          key: "remboursement-create"

        },
        component: () => import("../views/remboursements/pay.vue"),
      },
    ]
  },
  {
    path: "/annulations",
    name: "annulations",
    meta: {
      title: "Annulations",
      authRequired: true,
      key: "rapport-stocks"

    },
    component: () => import("../views/annulations/index.vue"),
  },
  {
    path: "/annulations/:id/non-livres",
    name: "annulationNonLivre",
    meta: {
      title: "Annulations",
      authRequired: true,
      key: "annulations"

    },
    component: () => import("../views/annulations/cancel.vue"),
  },

  {
    path: "/rapport-stock-rupture",
    name: "rapportStockRupture",
    meta: {
      title: "Rapport de stock",
      authRequired: true,
      key: "rapport-stocks"

    },
    component: () => import("../views/rapports/rapport_rupture_stock.vue"),
  },


  {
    path: "/produits",
    name: "produits",
    meta: {
      title: "Produits",
      authRequired: true,
      key: 'produits'

    },
    children:[
      {
        path: "",
        name: "produitListe",
        meta: {
          title: "Produits",
          authRequired: true,
          key: 'liste-produit'

        },
        component: () => import("../views/produits/index.vue"),
      },
      {
        path: "create",
        name: "produitCreate",
        meta: {
          title: "Produits",
          authRequired: true,
          key: 'create-produit'

        },
        component: () => import("../views/produits/create.vue"),
      },
      {
        path: ":id/edit",
        name: "produitEdit",
        meta: {
          title: "Produits",
          authRequired: true,
          key: 'edit-produit'

        },
        component: () => import("../views/produits/edit.vue"),
      },
      {
        path: ":id/declaration-perte",
        name: "declarationPerte",
        meta: {
          title: "Déclaration de perte",
          authRequired: true,
          key: "rapport-stocks"

        },
        component: () => import("../views/declarationPerte.vue"),
      },

      {
        path: ":id/:qte/print-label",
        name: "printLabel",
        meta: {
          title: "Produits",
          authRequired: true,
          key: 'print-label'

        },
        component: () => import("../views/produits/labelPrint.vue"),
      },
    ]
  },
  {
    path: "/categorie-produits",
    name: "categorieProduits",
    meta: {
      title: "Catégorie de produits",
      authRequired: true,
      key: "categorie_produits"
    },
    children:[
      {
        path: "",
        name: "categorieProduitsListe",
        meta: {
          title: "Catégorie de produits",
          authRequired: true,
          key: "liste-categorie_produits"
        },
        component: () => import("../views/categorie-produits/index.vue"),
      },
      {
        path: "create",
        name: "categorieProduitCreate",
        meta: {
          title: "Catégorie de produits",
          authRequired: true,
          key: "create-categorie_produits"

        },
        component: () => import("../views/categorie-produits/create.vue"),
      },
      {
        path: ":id/edit",
        name: "CategorieProduitEdit",
        meta: {
          title: "Catégorie de produits",
          authRequired: true,
          key: "edit-categorie_produits"

        },
        component: () => import("../views/categorie-produits/edit.vue"),
      },
    ]
  },
  {
    path: "/unites",
    name: "unites",
    meta: {
      title: "Unité de mésure",
      authRequired: true,
      key: "unites"
    },
    children:[
      {
        path: "",
        name: "uniteListe",
        meta: {
          title: "Unité de mesure",
          authRequired: true,
          key: "liste-unites"
        },
        component: () => import("../views/unites/index.vue"),
      },
      {
        path: "create",
        name: "uniteCreate",
        meta: {
          title: "Unité de mesure",
          authRequired: true,
          key: "create-unites"

        },
        component: () => import("../views/unites/create.vue"),
      },
      {
        path: ":id/edit",
        name: "uniteEdit",
        meta: {
          title: "Clients",
          authRequired: true,
          key: "edit-unites"

        },
        component: () => import("../views/unites/edit.vue"),
      },
    ]
  },
  {
    path: "/clients",
    name: "clients",
    meta: {
      title: "Clients",
      authRequired: true,
      key: "clients"
    },
    children:[
      {
        path: "",
        name: "clientListe",
        meta: {
          title: "Liste des clients",
          authRequired: true,
          key: "liste-client"
        },
        component: () => import("../views/clients/index.vue"),
      },
      {
        path: "create",
        name: "uniteCreate",
        meta: {
          title: "Unité de mesure",
          authRequired: true,
          key: "create-unites"

        },
        component: () => import("../views/unites/create.vue"),
      },
      {
        path: ":id/edit",
        name: "uniteEdit",
        meta: {
          title: "Clients",
          authRequired: true,
          key: "edit-unites"

        },
        component: () => import("../views/unites/edit.vue"),
      },
    ]
  },
  {
    path: '/caisse/ouvrir',
    name: 'caisse-ouvrir',
    component: () => import('../views/paiements/caisse/ouvrir.vue'),
  },
  {
    path: "/fournisseurs/paiements",
    name: "paiementFournisseur",
    meta: {
      title: "Paiement fournisseur",
      authRequired: true,
      key: "paiement-fournisseurs"
    },
    children:[
      {
        path: "",
        name: "paiementFournisseurListe",
        meta: {
          title: "Paiement Fournisseur",
          authRequired: true,
          key:"liste-paiement_fournisseur"
        },
        component: () => import("../views/paiements/fournisseurs/index.vue"),
      },
      {
        path: "create",
        name: "paiementFournisseurCreate",
        meta: {
          title: "Paiement Fournisseur",
          authRequired: true,
          key:"create-paiement_fournisseur"

        },
        component: () => import("../views/paiements/fournisseurs/create.vue"),
      },
      {
        path: ":id/invoice",
        name: "paiementFournisseurInvoice",
        meta: {
          title: "Paiement Fournisseur",
          authRequired: true,
          key:"print-paiement_fournisseur"

        },
        component: () => import("../views/paiements/fournisseurs/receipt.vue"),
      },
    ]
  },
  {
    path: "/clients/paiements",
    name: "clientPaiements",
    meta: {
      title: "Paiement clients",
      authRequired: true,
      key: "paiement-clients"
    },
    children:[
      {
        path: "",
        name: "paiementClientListe",
        meta: {
          title: "Paiement Client",
          authRequired: true,
          key:"liste-paiement_client"
        },
        component: () => import("../views/paiements/clients/index.vue"),
      },
      {
        path: "create",
        name: "paiementClientCreate",
        meta: {
          title: "Paiement Fournisseur",
          authRequired: true,
          key:"create-paiement_fournisseur"

        },
        component: () => import("../views/paiements/clients/create.vue"),
      },
      {
        path: ":id/invoice",
        name: "paiementClientInvoice",
        meta: {
          title: "Paiement Client",
          authRequired: true,
          key:"print-paiement_fournisseur"

        },
        component: () => import("../views/paiements/clients/receipt.vue"),
      },
    ]
  },
  {
    path: "/reports",
    name: "reports",
    meta: {
      title: "Rapports",
      authRequired: true,
      key: "reports"
    },
    children:[
      {
        path: "mouvement-stocks",
        name: "reportMouvementStock",
        meta: {
          title: "Mouvement de stock",
          authRequired: true,
          key:"report-mouvement-stock"
        },
        component: () => import("../views/reports/mouvement_stocks.vue"),
      },
      {
        path: "journal-ventes",
        name: "reportJournalVente",
        meta: {
          title: "Journal des ventes",
          authRequired: true,
          key:"report-journal-ventes"
        },
        component: () => import("../views/reports/journal_vente.vue"),
      },
      {
        path: "details-ventes",
        name: "reportDetailsVente",
        meta: {
          title: "Détails des ventes",
          authRequired: true,
          key:"report-journal-ventes"
        },
        component: () => import("../views/reports/details_vente.vue"),
      },
      {
        path: "details-achats",
        name: "reportDetailsAchats",
        meta: {
          title: "Détails des achats",
          authRequired: true,
          key:"report-journal-achats"
        },
        component: () => import("../views/reports/details_achats.vue"),
      },
      {
        path: "journal-achats",
        name: "reportJournalAchat",
        meta: {
          title: "Journal des achats",
          authRequired: true,
          key:"report-journal-achats"
        },
        component: () => import("../views/reports/journal_achats.vue"),
      },
      {
        path: "journal-livraisons",
        name: "reportJournalLivraison",
        meta: {
          title: "Journal des livraisons",
          authRequired: true,
          key:"report-journal-livraisons"
        },
        component: () => import("../views/reports/journal_livraison.vue"),
      },
      {
        path: "journal-caisses",
        name: "reportJournalCaisse",
        meta: {
          title: "Journal de caisse",
          authRequired: true,
          key:"report-journal-caisse"
        },
        component: () => import("../views/reports/journal_caisse.vue"),
      },
      {
        path: "impayes",
        name: "reportImpayes",
        meta: {
          title: "Journal des impayés",
          authRequired: true,
          key:"report-journal-impayes"
        },
        component: () => import("../views/reports/rapport-impaye.vue"),
      },
      {
        path: "retours",
        name: "reportRetours",
        meta: {
          title: "Journal des retours",
          authRequired: true,
          key:"report-journal-retour"
        },
        component: () => import("../views/reports/journal_retour.vue"),
      },
      {
        path: "stocks",
        name: "reportStocks",
        meta: {
          title: "Journal des stocks",
          authRequired: true,
          key:"report-stocks"
        },
        component: () => import("../views/reports/rapport_stock.vue"),
      },
      {
        path: "benefices",
        name: "reportBenefice",
        meta: {
          title: "Journal des Benefice",
          authRequired: true,
          key:"report-benefices"
        },
        component: () => import("../views/reports/rapport-benefice.vue"),
      },
      {
        path: "non-livres",
        name: "reportNonLivre",
        meta: {
          title: "Journal des non livres",
          authRequired: true,
          key:"report-benefices"
        },
        component: () => import("../views/reports/ProduitsNonLivres.vue"),
      },
      {
        path: "sortie-produits",
        name: "reportSortieProduit",
        meta: {
          title: "Sortie de produits",
          authRequired: true,
          key:"report-benefices"
        },
        component: () => import("../views/reports/ProduitsSortis.vue"),
      },

    ]
  },

  {
    path: "/depenses",
    name: "depenses",
    meta: {
      title: "Dépenses",
      key:"report-benefices",
      authRequired: true,
    },
    children:[
      {
        path: "",
        name: "depenseListe",
        meta: {
          title: "Dépenses",
          key:"depense-list",
          authRequired: true,
        },
        component: () => import("../views/depenses/index.vue"),
      },
      {
        path: "create",
        name: "depenseCreate2s",
        meta: {
          title: "Dépenses",
          authRequired: true,
          key:"depense-create",

        },
        component: () => import("../views/depenses/create.vue"),
      },
    ]
  },
  {
    path: "/retours",
    name: "retours",
    meta: {
      title: "Retours",
      authRequired: true,
      key: "sales-invoice-retour-list"
    },
    children:[
      {
        path: "",
        name: "retourListe",
        meta: {
          title: "Dépenses",
          authRequired: true,
        },
        component: () => import("../views/retours/index.vue"),
      },
      {
        path: "create",
        name: "depenseCreate",
        meta: {
          title: "Dépenses",
          authRequired: true,
        },
        component: () => import("../views/depenses/create.vue"),
      },
    ]
  },
  {
    path: "/configurations",
    name: "configurations",
    meta: {
      title: "Configurations",
      authRequired: true,
    },
    children:[
      {
        path: "boutiques",
        name: "configurationsBoutiques",
        meta: {
          title: "Configurations",
          authRequired: true,
        },
        children:[
          {
            path: "",
            name: "configurationsBoutiqueListe",
            meta: {
              title: "Configurations",
              authRequired: true,
            },
            component: () => import("../views/configurations/boutiques/index.vue"),
          },
          {
            path: "create",
            name: "configurationsBoutiqueCreate",
            meta: {
              title: "Configurations",
              authRequired: true,
            },
            component: () => import("../views/configurations/boutiques/create.vue"),
          },
          {
            path: ":id/edit",
            name: "configurationsBoutiqueEdits",
            meta: {
              title: "Configurations",
              authRequired: true,
            },
            component: () => import("../views/configurations/boutiques/edit.vue"),
          },
        ]
      },
      {
        path: "entrepots",
        name: "configurationsEntrepots",
        meta: {
          title: "Configurations",
          authRequired: true,
        },
        children:[
          {
            path: "",
            name: "configurationsEntrepotsListe",
            meta: {
              title: "Configurations",
              authRequired: true,
            },
            component: () => import("../views/configurations/entrepots/index.vue"),
          },
          {
            path: "create",
            name: "configurationsEntrepotCreate",
            meta: {
              title: "Configurations",
              authRequired: true,
            },
            component: () => import("../views/configurations/entrepots/create.vue"),
          },
          {
            path: ":id/edit",
            name: "configurationsEntrepotEdit",
            meta: {
              title: "Configurations",
              authRequired: true,
            },
            component: () => import("../views/configurations/boutiques/edit.vue"),
          },
        ]
      },
      {
        path: "roles",
        name: "configurationsRoles",
        meta: {
          title: "Configurations",
          authRequired: true,
        },
        children:[
          {
            path: "",
            name: "configurationsRolesListe",
            meta: {
              title: "Configurations",
              authRequired: true,
            },
            component: () => import("../views/configurations/roles/index.vue"),
          },
          {
            path: "create",
            name: "configurationsRoleCreate",
            meta: {
              title: "Configurations",
              authRequired: true,
            },
            component: () => import("../views/configurations/roles/create.vue"),
          },
          {
            path: ":id/edit",
            name: "configurationsRoleEdit",
            meta: {
              title: "Configurations",
              authRequired: true,
            },
            component: () => import("../views/configurations/roles/edit.vue"),
          },
        ]
      },
      {
        path: "users",
        name: "configurationUsers",
        meta: {
          title: "Configurations",
          authRequired: true,
        },
        children:[
          {
            path: "",
            name: "configurationsUserListe",
            meta: {
              title: "Configurations",
              authRequired: true,
            },
            component: () => import("../views/configurations/users/index.vue"),
          },
          {
            path: "create",
            name: "configurationsUserCreate",
            meta: {
              title: "Configurations",
              authRequired: true,
            },
            component: () => import("../views/configurations/users/create.vue"),
          },
          {
            path: ":id/edit",
            name: "configurationsUserEdit",
            meta: {
              title: "Configurations",
              authRequired: true,
            },
            component: () => import("../views/configurations/users/edit.vue"),
          },
        ]
      },
    ]
  },
  {
    path: "/impayes-notifications",
    name: "reportImpayesNotification",
    meta: {
      title: "Journal des impayés",
      authRequired: true,
      key:"report-journal-impayes"
    },
    component: () => import("../views/reports/notification-impaye.vue"),
  },

];